// If domain is empty, the code will derive it from current URL
// Otherwise, set it to a particular domain such as 'https://test.mynuskin.com'
var AppConfig = {
    clientId: '34bbbd1df8a946068d19eec5f92c76bd',
    clientSecret: '3a6b7b98e4e647ed9E278EACA3A8BF9D',
    domain: '',
    env: 'test'
};

export default AppConfig;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/config-manager/appConfig.js
// module id = 230
// module chunks = 0